import { render, staticRenderFns } from "./CancelationPolicyItemDelete.vue?vue&type=template&id=437d1e0a&scoped=true&"
import script from "./CancelationPolicyItemDelete.vue?vue&type=script&lang=js&"
export * from "./CancelationPolicyItemDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437d1e0a",
  null
  
)

export default component.exports